__turbopack_context__.v({
  "MuiChip-label": "chip-module-scss-module___N_7BW__MuiChip-label",
  "chip": "chip-module-scss-module___N_7BW__chip",
  "default": "chip-module-scss-module___N_7BW__default",
  "icon": "chip-module-scss-module___N_7BW__icon",
  "u-animation-bounce": "chip-module-scss-module___N_7BW__u-animation-bounce",
});
